module.exports = __webpack_public_path__ + "cart-feature-glasses/cart-feature-glasses-d02cceceef24496d2ff862ebc214b372.png";